import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto max-w-xl px-4 py-24 text-center" data-testid="not-found">
      <p className="font-mono text-sm font-bold text-brand-teal">404</p>
      <h1 className="mt-3 font-display text-4xl font-bold text-brand-navy sm:text-5xl">
        This page rolled a nat 1
      </h1>
      <p className="mt-4 text-slate-600">The page you were looking for isn&apos;t in our library.</p>
      <Link
        to="/"
        className="btn-primary mt-8 inline-flex rounded-full px-6 py-3 text-sm font-bold uppercase tracking-wide"
      >
        Back to home
      </Link>
    </div>
  );
}
